import type { PublicProduct } from '../graphql/public'
import { activeVariants } from '../lib/catalog'
import { Markers } from './Markers'
import { Deposit, Price } from './Price'
import { SoldOutBand } from './SoldOutBand'

// The one-line row: name, markers inline after it, price right. Used by the screen-2
// main list (34 px) and by the extras column (30 px).
//
// A product with more than one active variant prints one price per variant in the
// same 170 px right-aligned columns the header labels sit over — the screen-2 main
// list is a single-variant list today (Curritos), but the lunch program puts the
// two-variant Curries there and one price would be a wrong price on the wall.
export function LineRow({
  product,
  nameSize = 30,
  markerSize = 20,
  priceSize = 30,
  pad = 8,
  markers = 'all',
  truncateName = true,
}: {
  product: PublicProduct
  nameSize?: number
  markerSize?: number
  priceSize?: number
  pad?: number
  /** Which markers to show; the extras column shows dietary only (build-guide §4). */
  markers?: 'all' | 'dietary'
  /** When false the name keeps its full width and the markers give way instead. */
  truncateName?: boolean
}) {
  const variants = activeVariants(product)
  if (variants.length === 0) return null
  return (
    <div
      className={
        'flex items-center justify-between space-x-[20px] border-b-2 border-brand-line' +
        (product.sold_out ? ' opacity-60' : '')
      }
      style={{ paddingTop: pad, paddingBottom: pad }}
    >
      <div className="flex items-center space-x-[16px] min-w-0">
        <div
          className={
            'font-primary font-bold leading-[1.1] text-secondary-800 whitespace-nowrap' +
            (truncateName ? ' overflow-hidden text-ellipsis' : ' flex-none')
          }
          style={{ fontSize: nameSize }}
        >
          {product.name}
        </div>
        <div className={truncateName ? 'flex items-center' : 'flex items-center min-w-0 overflow-hidden'}>
          {product.sold_out ? (
            <SoldOutBand size={markerSize - 6} />
          ) : (
            <Markers product={product} size={markerSize} kinds={markers} />
          )}
        </div>
      </div>
      <div className="flex items-center whitespace-nowrap">
        {variants.map((v) => (
          <div key={v.id} className={variants.length > 1 ? 'w-[170px] text-right' : ''}>
            <Price cents={v.price_cents} size={priceSize} />
            <Deposit cents={v.deposit_cents} />
          </div>
        ))}
      </div>
    </div>
  )
}
